import { useLocalisation } from "@3plearning/lingui-cdn";
import PropTypes from "prop-types";
import React, { useState } from 'react';
import moment from 'moment';
import { Calendar } from "@3plearning/react-components";
import { useDispatch } from "react-redux";

import { dismissModal } from "../../../../containers/modal-manager/modal-manager-actions";

import AssignLaterModalInner from "./styled";

const defaultDateFormat = 'YYYY-MM-DD';

const getTranslations = ({ i18n }) => ({
  START_TIME_TEXT: i18n.t`START TIME`,
  END_TIME_TEXT: i18n.t`END TIME`,
  ACCEPT_BUTTON_TEXT: i18n.t`Accept`,
  CANCEL_BUTTON_TEXT: i18n.t`Cancel`,
  START_DATE_PLACEHOLDER_TEXT: i18n.t`Start date`,
  END_DATE_PLACEHOLDER_TEXT: i18n.t`End date`
});

const AssignDateModal = ({ callback }) => {
  const dispatch = useDispatch();

  const { i18n } = useLocalisation();

  moment.locale(i18n.language);

  const [dateSelected, setDateSelected] = useState({
    startDate: moment().format(defaultDateFormat),
    endDate: moment().add(1, 'day').format(defaultDateFormat)
  });
  const [timeSelected, setTimeSelected] = useState();
  const [enableAccept, setEnableAccept] = useState(true);

  const splitPeriod = (time) => `${time.slice(0, time.length - 2)} ${time.slice(time.length - 2)}`;
  const formatReturnedDate = ({ date, time }) => {
    const MOMENT_DATE_FORMAT = 'YYYY-MM-DD h:mm A';

    return moment(
      `${date} ${splitPeriod(time)}`,
      [MOMENT_DATE_FORMAT]
    ).toISOString()
  }

  const {
    START_TIME_TEXT,
    END_TIME_TEXT,
    ACCEPT_BUTTON_TEXT,
    CANCEL_BUTTON_TEXT,
    START_DATE_PLACEHOLDER_TEXT,
    END_DATE_PLACEHOLDER_TEXT
  } = getTranslations({ i18n });

  const onDateChangeHandler = (startDate, endDate) => setDateSelected({ startDate, endDate });
  const onTimeChangeHandler = (newTime) => setTimeSelected(newTime);
  const onSubmit = () => {
    setEnableAccept(false);

    const startDate = formatReturnedDate({
      date: dateSelected.startDate,
      time: timeSelected[0]
    });
    const dueDate = formatReturnedDate({
      date: dateSelected.endDate,
      time: timeSelected[1]
    });

    callback(startDate, dueDate);
  }

  const defaultProps = {
    range: {
      startDate: moment().format(defaultDateFormat),
      endDate: moment().add(1, 'year').format(defaultDateFormat)
    },
    closedOnLoad: true,
    enableAccept,
    includeTimeRange: true,
    onClose: () => {},
    onDatesPicked: onDateChangeHandler,
    onTimesPicked: onTimeChangeHandler,
    onDateTimeSubmit: () => onSubmit(),
    onDateTimeClose: () => dispatch(dismissModal()),
    weeklyRangeOnly: false,
    reactDatesConfig: {
      startDatePlaceholderText: START_DATE_PLACEHOLDER_TEXT,
      endDatePlaceholderText: END_DATE_PLACEHOLDER_TEXT
    },
    labels: {
      buttons: {
        accept: ACCEPT_BUTTON_TEXT,
        cancel: CANCEL_BUTTON_TEXT
      },
      timeRange: {
        start: START_TIME_TEXT,
        end: END_TIME_TEXT
      }
    }
  }

  return (
    <AssignLaterModalInner>
      <Calendar {...defaultProps} />
    </AssignLaterModalInner>
  )
}

AssignDateModal.propTypes = {
  callback: PropTypes.func
}

export default AssignDateModal;